module.exports = __webpack_public_path__ + "61decb535e7bba5bd6ba1605cd6d58f8.svg";